module.exports = __webpack_public_path__ + "media/images/icons/country_flags/xk-80de9468c3699b84d6aaf6129af66913.svg";